// https://stackoverflow.com/a/78721304/826371
import { Text, TextProps, Tooltip } from "@mantine/core";
import { useMergedRef, useResizeObserver } from "@mantine/hooks";
import { FC, ReactNode, useRef } from "react";

export interface OverflowTooltipProps {
  children: ReactNode;
}

const OverflowTooltip: FC<OverflowTooltipProps & TextProps> = ({
  children,
  ...props
}) => {
  const elementRef = useRef<HTMLDivElement>(null);
  const [resizeRef, rect] = useResizeObserver<HTMLDivElement>();
  const mergedRef = useMergedRef(elementRef, resizeRef);

  // rect.width drives re-evaluation when the element resizes
  void rect;
  const isOverflowed =
    (elementRef.current?.scrollWidth ?? 0) >
    (elementRef.current?.clientWidth ?? 0);

  return (
    <Tooltip
      label={children}
      disabled={!isOverflowed}
      events={{ hover: true, focus: false, touch: true }}
    >
      <Text
        ref={mergedRef}
        truncate
        {...props}
        style={{
          cursor: "default",
          textDecoration: isOverflowed ? "underline dashed" : "none",
          textWrap: "nowrap",
        }}
      >
        {children}
      </Text>
    </Tooltip>
  );
};

export default OverflowTooltip;
